import { IEquipmentAttributeTypes } from 'types/graphqlTypes'
import * as yup from 'yup'
import {
  IDoorTypes,
  IFloorTypes,
  IRoofTypes,
  ITrackTypes,
  IWallTypes,
} from 'apps/marketplace/types/equipment'
import { MORE_THAN_ZERO_MESSAGE } from '../../constants'

const TRACK_OPTION_VALUES = Object.values(ITrackTypes)
const ROOF_OPTION_VALUES = Object.values(IRoofTypes)
const WALL_OPTION_VALUES = Object.values(IWallTypes)
const FLOOR_OPTION_VALUES = Object.values(IFloorTypes)
const DOOR_OPTION_VALUES = Object.values(IDoorTypes)

export const DryVanSchemaObject = {
  /**
   * @example false
   */
  [IEquipmentAttributeTypes.can_reefer]: yup.boolean().default(false).notRequired(),
  /**
   * @example false
   */
  [IEquipmentAttributeTypes.load_bars]: yup.boolean().default(false).notRequired(),
  /**
   * @example false
   */
  [IEquipmentAttributeTypes.load_locks]: yup.boolean().default(false).notRequired(),
  /**
   * @example 16
   */
  [IEquipmentAttributeTypes.straps]: yup.number().moreThan(0, MORE_THAN_ZERO_MESSAGE).notRequired(),
  /**
   * @example 'E-Tracks'
   */
  [IEquipmentAttributeTypes.tracks]: yup
    .string()
    .oneOf([...TRACK_OPTION_VALUES, null])
    .nullable()
    .notRequired(),
  /**
   * @example '2017'
   */
  [IEquipmentAttributeTypes.not_older_than]: yup.string().notRequired(),
  /**
   * @example false
   */
  [IEquipmentAttributeTypes.food_grade]: yup.boolean().default(false).notRequired(),
  /**
   * @example false
   */
  [IEquipmentAttributeTypes.pallet_jack]: yup.boolean().default(false).notRequired(),
  /**
   * @example false
   */
  [IEquipmentAttributeTypes.lift_gate]: yup.boolean().default(false).notRequired(),
  /**
   * @example 'Metal Roof'
   */
  [IEquipmentAttributeTypes.roof_type]: yup
    .string()
    .oneOf([...ROOF_OPTION_VALUES, ''])
    .nullable()
    .notRequired(),
  /**
   * @example 'Fiberglass Walls'
   */
  [IEquipmentAttributeTypes.wall_type]: yup
    .string()
    .oneOf([...WALL_OPTION_VALUES, ''])
    .nullable()
    .notRequired(),
  /**
   * @example 'Wood Floor'
   */
  [IEquipmentAttributeTypes.floor_type]: yup
    .string()
    .oneOf([...FLOOR_OPTION_VALUES, ''])
    .nullable()
    .notRequired(),
  /**
   * @example 'Swing Doors'
   */
  [IEquipmentAttributeTypes.door_type]: yup
    .string()
    .oneOf([...DOOR_OPTION_VALUES, ''])
    .nullable()
    .notRequired(),
}

export const DryVanSchema = yup.object(DryVanSchemaObject)

export type TDryVanSchema = yup.InferType<typeof DryVanSchema>
